import { Component, forwardRef, Input } from '@angular/core';
import { UIDropdown } from '@irohalab/deneb-ui';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { NgClass } from '@angular/common';

@Component({
    selector: 'app-multi-select',
    imports: [
    UIDropdown,
    NgClass
],
    templateUrl: './multi-select.component.html',
    styleUrl: './multi-select.component.less',
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            multi: true,
            useExisting: forwardRef(() => MultiSelectComponent),
        }
    ]
})
export class MultiSelectComponent implements ControlValueAccessor {

  private _selectList!: string[]
  @Input()
  set selectList(value: string[]) {
    this._selectList = value;
    this.selected = new Array<boolean>(value.length);
  }

  get selectList(): string[] {
    return this._selectList;
  }

  @Input()
  hint = '';

  selected!: boolean[];
  selectedValue: string[] = [];

  onChange = (value: any) => {};
  onTouched = () => {};

  isTouched = false;
  isDisabled = false;

  writeValue(obj: any): void {
    this.selectedValue = obj;
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState?(isDisabled: boolean): void {
    this.isDisabled = isDisabled;
  }

  onSelectValue(idx: number) {
    this.markAsTouched();
    if (this.selected[idx]) {
      const index = this.selectedValue.indexOf(this.selectList[idx]);
      this.selectedValue.splice(index, 1);
    } else {
      this.selectedValue.push(this.selectList[idx]);
    }
    this.selected[idx] = !this.selected[idx];
    this.onChange(this.selectedValue);
  }

  markAsTouched() {
    if (!this.isTouched) {
      this.onTouched();
      this.isTouched = true;
    }
  }

  deleteValueFromSelected(item: string): void {
    const idx = this.selectedValue.indexOf(item);
    const indexOfSelectList= this.selectList.indexOf(item);
    if (idx !== -1) {
      this.selectedValue.splice(idx, 1);
      if (indexOfSelectList !== -1) {
        this.selected[indexOfSelectList] = false;
      }
    }
    this.onChange(this.selectedValue);
  }
}
